export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/60 via-background-50/40 to-background-100/60 z-[1]"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs font-medium text-accent-400 tracking-wide">实时更新 · 匿名安全</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight mb-4">
              51暗网
              <span className="block text-primary-400 mt-1">暗网入门与深度网安全指南</span>
            </h1>

            <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-3">
              专注暗网知识科普与深度网访问安全，从暗网是什么到怎么进入，从暗网浏览器选择到Tor浏览器下载配置，覆盖暗网网址导航、深度网资源索引与匿名访问技术。本站持续更新暗网安全访问策略，同时聚合全网吃瓜爆料内容，提供匿名投稿通道。
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              无论你是暗网入门新手还是深度网探索者，这里都有你需要的安全指南与一手资讯。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-primary-400 font-heading text-2xl font-bold">300+</span>
                <span className="text-xs text-foreground-500">安全指南文章</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-accent-400 font-heading text-2xl font-bold">每日更新</span>
                <span className="text-xs text-foreground-500">吃瓜爆料资讯</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-secondary-400 font-heading text-2xl font-bold">全平台</span>
                <span className="text-xs text-foreground-500">匿名安全访问</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm rounded-md transition-all duration-200 whitespace-nowrap text-center"
              >
                开始探索指南
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3 bg-background-100 hover:bg-background-200 border border-background-300 text-foreground-300 hover:text-foreground-100 font-medium text-sm rounded-md transition-all duration-200 whitespace-nowrap text-center"
              >
                安全访问入口
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-lg overflow-hidden border border-background-200/50">
              <div className="absolute inset-0 bg-gradient-to-tr from-background-100/40 via-transparent to-primary-500/10 z-[1]"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20digital%20landscape%20with%20abstract%20geometric%20network%20nodes%20and%20circuit%20patterns%2C%20warm%20amber%20and%20deep%20charcoal%20color%20palette%2C%20cybersecurity%20aesthetic%2C%20hidden%20internet%20concept%20art%2C%20minimalist%20yet%20atmospheric%20composition%20with%20subtle%20glowing%20elements%2C%20no%20text%2C%20dark%20gradient%20background%20with%20interconnected%20lines%20and%20nodes%20representing%20anonymous%20network%20communication&width=800&height=600&seq=hero-dark-web-2026&orientation=landscape"
                alt="51暗网 - 暗网入门与深度网安全指南主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}